import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from 'app/shared/toast/toast';
import { AdminApi } from '../admin-api';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-pdf-template-create-dialog',
  templateUrl: './pdf-template-create-dialog.component.html',
  styleUrls: ['./pdf-template-create-dialog.component.css']
})
export class PdfTemplateCreateDialogComponent implements OnInit {

   error: any;
   data: any;

  constructor(
    private translate: TranslateService,
    private toast: Toast,
    private api: AdminApi,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<PdfTemplateCreateDialogComponent>
  ) { }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {

  }

   createTemplate(templateName: HTMLInputElement): void {
      if (templateName.value.trim().length === 0) {
            templateName.focus();
            return;
      }
      if (/[<|>\\\/:?*"]/g.test(templateName.value)) {
         this.translate.get('alert.create_folder_error').subscribe((s) => {
            this.error = s;
         });
         return;
      }
      if (templateName.value.lastIndexOf('.') === templateName.value.length - 1) {
         this.translate.get('alert.create_folder_error_dot').subscribe((s) => {
            this.toast.error(s);
         });
      }
      if (window.localStorage.getItem('siteCode')){
         this.api.newBlank(localStorage.getItem('siteCode'), templateName.value).subscribe(data => {
            if (data.duplicate) {
               this.translate.get('pdf-template.duplicate-pdf-template').subscribe((s) => {
                  this.error = s;
               });
            } else {
               this.dialogRef.close(data);
            }

            // this.getListPdfTemplate('');
         }, e => {
            this.handleErrors(e);
         });
      }
   }

   handleErrors(e: any) {
      if (e.status === 404) {
         this.toast.error('Service Not Found.');
      }
   }

}
